import React, { createContext, useContext, useState } from 'react';
const AppContext = createContext({});
export function AppProvider({ children }) {
  const [appState, setAppState] = useState({});
  return <AppContext.Provider value={{ appState, setAppState }}>{children}</AppContext.Provider>;
}
export function useApp() { return useContext(AppContext); }
